import { ChangeDetectorRef, Directive, Input, OnDestroy, ViewChild, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { AccessibilitySettingsComponent } from '@app/shared/component/accessibility-settings/accessibility-settings.component';
import { UserInviteComponent } from '@app/shared/component/user-invite/user-invite.component';
import {
  overlay_folder_admins_tutorial_article,
  overlay_folder_admins_tutorial_code,
  overlay_folder_sharing_tutorial_article,
  overlay_folder_sharing_tutorial_code,
} from '@app/shared/models/constants/constant';
import { AuthService, CommonService, UserConnectionService } from '@app/shared/services';
import { ScriptService } from '@app/shared/services/script/script.service';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ShareTypeControl } from '../../share-type-control/share-type-control.component';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { NotifySharingUpdateService } from '@app/shared/services/notify-sharing-update/notify-sharing-update.service';

@Directive()
export class AccessManagerBase implements OnDestroy {
  @Input('nonDialogModalData') nonDialogModalData;
  @Input('hideCloseIcon') hideCloseIcon = false;
  @Input() inlineComponent = false;
  title;
  objectName;
  listHeader;
  addShowButtonText;
  private parenturl;
  currentSectionTitle;
  showAddButton = false;
  showShareButton = false;
  showHeader = true;
  currentUser: any;
  modalData: any;
  users: Array<any> = [];
  TotalUsers: any;
  parentDialogRef;
  private parentCommonService;
  private parentUserConnectionService;
  connectionPlaceholderText;
  relationships: any;
  connectionUserFormControl = new UntypedFormControl();
  selectedUser;
  isUserSelected = false;
  existingUsers;
  emptyExistingUsersText;
  showShareTypeOptions = false;
  newShareTypeDetails;
  sharedObjectType;
  private childDialog;
  private changeDetector;
  private scriptService;
  protected documentService;
  protected _notifySharingUpdateService;
  vaultStateObject;
  emptyConnectionText;
  checkconnectionList = false;
  zerostateTextMobile;
  dialogName;
  isFromTemplate = false;
  isFromFolder = false;
  isManageAdmin = false;
  isShareFolder = false;
  mobileText;
  screenHeight: number;
  screenWidth: number;
  showQuestionMarkDropdown = false;
  sharingTutorialArticle = overlay_folder_sharing_tutorial_article;
  adminTutorialArticle = overlay_folder_admins_tutorial_article;
  showLoader = true;
  subscription = new Subscription();
  @ViewChild(ShareTypeControl) child: ShareTypeControl;
  resizeObservable$: Observable<Event>;
  sharingTitle: string;
  sharingSubtitle: string;
  adminName: string;
  markSharingAsComplete: boolean = false;
  parentFun: EventEmitter<any> = new EventEmitter();
  constructor(
    authService: AuthService,
    router: Router,
    commonService: CommonService,
    userConnectionService: UserConnectionService,
    dialog: MatDialog,
    vaultService: VaultStoreEffects,
    script?: ScriptService,
    cd?: ChangeDetectorRef,
    _notifySharingUpdateService?: NotifySharingUpdateService
  ) {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    // this.parentDialogRef = dialogRef;
    this.parenturl = router;
    this.parentCommonService = commonService;
    this.parentUserConnectionService = userConnectionService;
    this.childDialog = dialog;
    this.changeDetector = cd;
    this.scriptService = script;
    this._notifySharingUpdateService = _notifySharingUpdateService;
    this.subscription.add(
      authService.$user.subscribe((data) => {
        if (data) {
          this.currentUser = data;
        } else {
          this.currentUser = null;
          router.navigate(['/']);
        }
      })
    );

    this.subscription.add(
      vaultService.vaultObject.subscribe((state) => {
        this.vaultStateObject = state;
      })
    );

    this.viewTutorial();
    this.viewSharingTutorial();

    if (router.url.includes('admin')) {
      this.adminName =
        localStorage.getItem('adminFirstName') || localStorage.getItem('admin') ? JSON.parse(localStorage.getItem('admin'))['first_name'] : '';
    } else {
      this.adminName = null;
    }
  }

  closeDialog() {
    if (this.modalData.ask_mark_complete && !this.markSharingAsComplete) {
      const dialogRef = this.childDialog.open(SharedConfirmationDialogComponent, {
        width: '400px',
        data: {
          title: 'Mark Complete',
          materialIcon: 'info',
          text: 'Do you want to mark Sharing as complete?',
          proceedTitle: `Yes`,
          backBUttonTitle: `No`,
          showCancelBtn: true,
        },
      });
      this.subscription.add(
        dialogRef.afterClosed().subscribe((confirmation) => {
          if (confirmation) {
            this.parentDialogRef.close({
              ...this.existingUsers,
              mark_complete: true,
            });
          } else {
            // this.dialogRef.close();
            this.parentDialogRef.close({
              ...this.existingUsers,
              mark_complete: this.markSharingAsComplete,
            });
          }
        })
      );
    } else {
      const vaultId = this.modalData?.vaultId ? this.modalData?.vaultId : this.vaultStateObject.vaultId;
      if (!this.isManageAdmin && this.parenturl.url.includes('/vault/my-vault') && this.currentUser.id) {
        this.parentCommonService.udpatesharedByMeData(this.currentUser.id, vaultId);
      }
      if (!this.isManageAdmin && this.parenturl.url.includes('/collaboration/admin-vault?admin=true') && this.vaultStateObject.userId) {
        this.parentCommonService.udpatesharedByMeData(this.vaultStateObject.userId, vaultId);
      }
      this.parentDialogRef.close({ ...this.existingUsers, mark_complete: this.markSharingAsComplete });
    }
  }

  superNgOnInit() {
    this.subscription.add(
      this.connectionUserFormControl.valueChanges
        .pipe(
          startWith(''),
          map((value) => this.filterConnectedUsers(value))
        )
        .subscribe((response) => {
          this.users = response;
        })
    );

    //  this.parentCommonService.getRelationahips().subscribe(results => {
    //    this.relationships = results.data;
    //  });

    this.getAllConnections();
  }

  private filterConnectedUsers(value) {
    if (this.TotalUsers) {
      return this.TotalUsers.filter((user) => user.full_name.toLowerCase().includes(value.toLowerCase()));
    }
  }

  clearAutoCompleteValue() {
    this.selectedUser = null;
    this.isUserSelected = false;
    this.connectionUserFormControl.setValue('');

    setTimeout(() => {
      //wait a bit and remove focus from auto complete
      const nativeUserControl: any = document.querySelector('.mat-autocomplete-trigger');
      nativeUserControl.blur();
    }, 100);
  }

  getAllConnections() {
    this.subscription.add(
      this.parentUserConnectionService
        .getConnections('user', { search_type: 'existing', user_id: this.vaultStateObject.userId })
        .subscribe((data) => {
          const finalData = [];
          data.forEach((element) => {
            let tempEllemt = {
              ...element,
              name: '',
            };
            tempEllemt.id = element?.user_id;
            tempEllemt.name = element?.user_first_name + ' ' + element?.user_last_name;
            finalData.push(tempEllemt);
          });
          //get all connections but exclude existing users
          if (this.existingUsers) {
            this.users = this.TotalUsers = [...finalData.filter((u) => this.existingUsers.filter((e) => e.user_id == u.user_id).length == 0)];
          } else {
            this.users = this.TotalUsers = [...finalData];
          }
          this.checkconnectionList = true;
        })
    );
  }

  selectConnectedUser(userData) {
    // if ($event.source.selected) {
    this.selectedUser = userData;
    this.isUserSelected = true;
    // }
  }

  launchNewShareOptionsDialog(success, cancelled) {
    const accessibilityDialog = this.childDialog.open(AccessibilitySettingsComponent, {
      data: {
        sharedObjectType: this.sharedObjectType,
        shareDetails: null,
        profile_image: this.selectedUser.user_profile_image_url,
        name: this.selectedUser?.name,
        fromAutoComplete: true,
        currentUsername: this.currentUser.first_name + ' ' + this.currentUser.last_name,  
      },
      // width: '250px',
      // height: '380px',
      panelClass: 'full-window-dialog-2',
      autoFocus: false,
    });

    this.subscription.add(
      accessibilityDialog.afterClosed().subscribe((results) => {
        if (results) {
          this.newShareTypeDetails = results;
          success();
        } else {
          cancelled();
        }
      })
    );
  }

  addUserSharewithUser() {}

  deleteExistingUser(existingUser) {}

  updateExistingUser(value, existingUser) {}

  shareTypeUpdated(value) {}

  validateSelectedUser() {
    //  if(this.isUserSelected==false)
    //  {
    //   const dialogRef = this.parentDialogRef.open(SharedConfirmationDialogComponent, {
    //     width: '400px',
    //     data: { title: 'Warning', materialIcon: 'info', text: 'Please selected a user!', proceedTitle: 'Okay' }
    //   });
    //  }
  }

  openInviteModal() {
    this.closeDialog();
    const modalRef2 = this.childDialog.open(UserInviteComponent, {
      autoFocus: false,
      panelClass: 'full-window-dialog-2',
    });
  }

  updateSharingDetails(existingUser, sharedObjectType) {}

  closeQuestionMarkDropdown() {
    this.showQuestionMarkDropdown = false;
  }

  toggleDropdown() {
    this.showQuestionMarkDropdown = !this.showQuestionMarkDropdown;
  }

  viewTutorial() {
    let model = [{ name: 'overlay-folder-admins', src: `https://fast.wistia.com/embed/medias/${overlay_folder_admins_tutorial_code}.jsonp` }];

    this.scriptService.setScriptStore(model);
    this.changeDetector.markForCheck();

    this.subscription.add(
      this.scriptService.getScriptStore().subscribe((item) => {
        if (item && item.length) {
          this.scriptService
            .load('overlay-folder-admins')
            .then((data) => {})
            .catch((error) => {});

          this.changeDetector.markForCheck();
        }
      })
    );
  }

  viewSharingTutorial() {
    let model = [{ name: 'overlay-folder-sharing', src: `https://fast.wistia.com/embed/medias/${overlay_folder_sharing_tutorial_code}.jsonp` }];

    this.scriptService.setScriptStore(model);
    this.changeDetector.markForCheck();

    this.subscription.add(
      this.scriptService.getScriptStore().subscribe((item) => {
        if (item && item.length) {
          this.scriptService
            .load('overlay-folder-sharing')
            .then((data) => {})
            .catch((error) => {});

          this.changeDetector.markForCheck();
        }
      })
    );
  }

  getVideoUrl(): string {
    return `https://fast.wistia.com/embed/medias/${overlay_folder_admins_tutorial_code}.jsonp`;
  }

  getProperClass(): string {
    return `wistia_embed wistia_async_${overlay_folder_admins_tutorial_code} popover=true popoverContent=link`;
  }

  getSharingVideoUrl(): string {
    return `https://fast.wistia.com/embed/medias/${overlay_folder_sharing_tutorial_code}.jsonp`;
  }

  getSharingProperClass(): string {
    return `wistia_embed wistia_async_${overlay_folder_sharing_tutorial_code} popover=true popoverContent=link`;
  }

  setShareDetails(existingUser) {
    // it should return
    // share_date,
    // is_sealed,
    // is_editable,
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  onToggleChange(event: any) {
    if (event.checked) {
      this.markSharingAsComplete = event.checked;
      let status = this.markSharingAsComplete ? 'complete' : 'created';
      this._notifySharingUpdateService.sendData({ status: status });
      this.closeDialog();
    }
    if (!this.modalData?.showMarkAsComplete) {
      this.closeDialog();
    }
  }
}
